import { Card } from '@ipfabric/ui-components/Card/Card';
import { Link } from '@ipfabric/ui-components/Link/Link';
import { DEFAULT_APP_SETTING } from '@ipfabric/utils';
import type { AuthenticationFailureFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/authenticationFailure';
import type { AuthorizationFailureFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/authorizationFailure';
import type { BasicFailureFieldValues } from 'app/features/DiscoverySettingsForms/snippets/advancedCli/basicFailure';
import type { ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';

type Props = {
  form: UseFormReturn<
    BasicFailureFieldValues &
      AuthenticationFailureFieldValues &
      AuthorizationFailureFieldValues
  >;
  renderSnippet: (
    name: 'basicFailure' | 'authenticationFailure' | 'authorizationFailure',
  ) => ReactNode;
};

export const FailureHandling = (props: Props) => (
  <Card>
    <SearchableSection
      id='advanced-cli-failure-settings-card'
      highlightOn={['advancedCli']}
      className='p flex flex-col'
    >
      <div className='flex flex-row gap-xs'>
        <div className='text-default text-level-5 font-semibold font-heading'>
          Failure handling
        </div>
        <Link
          renderAs='button'
          onClick={() => {
            props.form.setValue(
              'cliRetryAuthFailure',
              DEFAULT_APP_SETTING.cliRetryLimit.authFail.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
            props.form.setValue(
              'cliRetryBasicFailure',
              DEFAULT_APP_SETTING.cliRetryLimit.default.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
            props.form.setValue(
              'commandAuthorizationFailureRetry',
              DEFAULT_APP_SETTING.cliRetryLimit.tacacs.retry.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
            props.form.setValue(
              'commandAuthorizationFailureDelay',
              DEFAULT_APP_SETTING.cliRetryLimit.tacacs.delay.toString(),
              { shouldDirty: true, shouldTouch: true },
            );
          }}
        >
          Reset to default values
        </Link>
      </div>
      <SearchableSection id='advanced-cli-basic-failure'>
        <div className='my-xs'>{props.renderSnippet('basicFailure')}</div>
      </SearchableSection>
      <SearchableSection id='advanced-cli-authentication-failure'>
        <div className='my-xs'>
          {props.renderSnippet('authenticationFailure')}
        </div>
      </SearchableSection>
      <SearchableSection id='advanced-cli-authorization-failure'>
        <div className='my-xs'>
          {props.renderSnippet('authorizationFailure')}
        </div>
      </SearchableSection>
    </SearchableSection>
  </Card>
);
